import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectHasNonEmbeddedSelection } from '../../store/company/slice';
import { setInputMessage, updateFormValues, clearConversation } from '../../store/chat/slice';
import submitInputMessage from '../../store/chat/submitInputMessage';
import { Heading } from '../../components/Typography';
import ChatInput from '../../components/ChatInput';
import styles from './ResearchPage.module.scss';
import SummariesView from './components/SummariesView';
import CompanyFilesLayout from '../../components/layout/CompanyFilesLayout/CompanyFilesLayout';
import { trackEvent } from '../../services/tracking';

const ResearchPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { selectedCompanies } = useAppSelector((state) => state.company);
  const hasNonEmbeddedSelection = useAppSelector(selectHasNonEmbeddedSelection);
  const [question, setQuestion] = useState('');

  useEffect(() => {
    dispatch(clearConversation());
  }, [dispatch]);

  const handleQuestionSubmit = () => {
    if (!question.trim()) return;

    trackEvent('Research Submit Question', {
      question,
      selectedCompanies: selectedCompanies.map((c) => c.ticker),
    });

    dispatch(setInputMessage(question));

    const companyIds = selectedCompanies.map((company) => company.id);
    if (companyIds.length > 0) {
      dispatch(updateFormValues({ filteredCompanyIds: companyIds }));
    }

    dispatch(submitInputMessage());
    setQuestion('');
    navigate('/chat');
  };

  const handleQuestionChange = (value: string) => {
    setQuestion(value);
  };

  const handleQuestionBlur = () => {
    if (question.trim()) {
      trackEvent('Research Question Edited', { question });
    }
  };

  const placeholder =
    selectedCompanies.length > 0
      ? `Enter a question about ${selectedCompanies.map((c) => `$${c.ticker}`).join(', ')}...`
      : 'Enter a question...';

  return (
    <div className={styles.researchPage}>
      <CompanyFilesLayout
        embeddedOnlyTicker={false}
        main={
          <>
            <div className={styles.summariesContainer}>
              {selectedCompanies.map((company) => (
                <div key={company.id} className={styles.summarySection}>
                  <Heading level={1}>{company.name}</Heading>
                  <SummariesView company={company} />
                </div>
              ))}
            </div>
            <div className={styles.chatInputContainer}>
              <ChatInput
                value={question}
                onChange={handleQuestionChange}
                onBlurChange={handleQuestionBlur}
                onSubmit={handleQuestionSubmit}
                isLoading={false}
                placeholder={placeholder}
                disabled={hasNonEmbeddedSelection}
                disabledTooltip="One of the selected companies isn't searchable yet."
              />
            </div>
          </>
        }
      />
    </div>
  );
};

export default ResearchPage;
